// Labels for the broker detail's provider launch audit (SM-643, SM-621
// phase 12). Every value is a closed contract enum (contracts
// brokerv1.LaunchDecision / LaunchDenyClass / ProviderRetryClass and the
// LaunchAuditEvent stage); an unknown value renders as the wire string,
// so a value added upstream is still shown, never hidden.
import type { Tone } from "./governance";

const DECISIONS: Record<string, { label: string; tone: Tone }> = {
  ALLOW: { label: "Allowed", tone: "success" },
  ALLOW_RESTRICTED: { label: "Allowed with restrictions", tone: "warning" },
  DENY: { label: "Denied", tone: "danger" },
};

export function launchDecisionLabel(decision: string): string {
  return DECISIONS[decision]?.label ?? decision;
}

export function launchDecisionTone(decision: string): Tone {
  return DECISIONS[decision]?.tone ?? "muted";
}

const DENY_CLASSES: Record<string, { label: string }> = {
  INVALID_OR_EXPIRED: { label: "Invalid or expired launch code" },
  ACCOUNT_UNAVAILABLE: { label: "Account unavailable" },
  PROVIDER_UNAVAILABLE: { label: "Provider unavailable" },
};

export function launchDenyClassLabel(denyClass: string): string {
  return DENY_CLASSES[denyClass]?.label ?? denyClass;
}

const STAGES: Record<string, { label: string }> = {
  SLUG: { label: "Launch URL" },
  EXCHANGE: { label: "Code exchange" },
  VALIDATE: { label: "Validation" },
  MAPPING: { label: "Identity mapping" },
  ONBOARDING: { label: "Onboarding" },
  POLICY: { label: "Account policy" },
  SESSION: { label: "Session" },
};

export function launchStageLabel(stage: string): string {
  return STAGES[stage]?.label ?? stage;
}

const OUTCOME_CLASSES: Record<string, { label: string }> = {
  committed: { label: "Succeeded" },
  definitive_failure: { label: "Definitive failure" },
  not_executed: { label: "Not executed" },
  retryable_read: { label: "Retryable" },
  ambiguous_money: { label: "Ambiguous outcome" },
  contract_violation: { label: "Contract violation" },
};

export function launchOutcomeClassLabel(outcomeClass: string): string {
  return OUTCOME_CLASSES[outcomeClass]?.label ?? outcomeClass;
}
